import { render, staticRenderFns } from "./CancelOnboarding.vue?vue&type=template&id=f0c3dfbe"
import script from "./CancelOnboarding.vue?vue&type=script&lang=js"
export * from "./CancelOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports